import { blue } from "../colors/index.js";
const secondaryColor = (mode)=>'light' === mode ? {
        main: blue["600"],
        highContrast: blue["800"],
        lowContrast: blue["150"]
    } : {
        main: blue["500"],
        highContrast: blue["300"],
        lowContrast: blue["700"]
    };
export { secondaryColor };

//# sourceMappingURL=secondary.js.map